import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
const introspectionQueryResultData = require("../../generated/fragmentTypes.json");

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});
